<style class="applicationStylesheet" type="text/css">
  
	.Campaigns {
		position: relative;
		box-sizing: border-box;
		background-color: rgba(255,255,255,1);
		margin: 0;
    padding: 0;
		--web-view-name: Current Campaigns;
		--web-view-id: Current_Campaigns;
		--web-enable-deep-linking: true;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  
  .Campaigns_Body {
    display: inline-block;
    padding: 1rem;
  }

.Current_Campaigns {

  cursor: pointer;
}
  .Start_a_New_Campaign_Wrapper {
    display: flex;
    justify-content: right;
    padding-right: 2rem;
    width: 100%;
  }

  button.main.new_campaign {
    margin: 1rem;
    display: flex;
  }
  button.main.new_campaign img {
    height: 2rem;
    padding-right: 2rem;
  }
  :global(.Current_Campaigns img:hover) {
    transform: scale(1.1);
    transition: 300ms;
  }
</style>
<script>
  import {getToken} from "../js-core/conn/auth/auth-main"
	import AdImg from "../components/shared/img/AdImg.svelte"
  function changeToPastCampaigns(adId){
    window.location.href = "#/advertiser/campaigns/past/" + adId
  }
  function changeToCurrentCampaigns(adId) {
    window.location.href = "#/advertiser/campaigns/current/" + adId
  }
  let getPriorAdsProm = getPriorAds()
  let getCurrentAdsProm = getCurrentAds()
  async function getCurrentAds() {
    try {
      const res = await BSFetch("ad-owner/running-ads", {
        method: "GET",
        headers: {
          authorization: getToken(),
          "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "no-cache"
      });
      if (res.status === 200) {
        const resBody = await res.json();
        return resBody.response.ads.reverse()
      } else {
        throw {message: "There was an error getting you current campaigns"}
      }
    } catch (e) {
      console.error(e)
      throw {message: "There was an error getting you current campaigns"}
    }
  }

  async function getPriorAds() {
    const res = await fetch(configs.baseUrl + "ad-owner/prior-ads", {
      method: "GET",
      headers: {
        authorization: getToken(),
        "Content-Type": "application/json"
      },
      mode: "cors",
      cache: "no-cache"
    });
    if (res.status === 200) {
      const resBody = await res.json();
      return resBody.response.adIds
    } else {
      throw {message: "There was an error getting your prior campaigns"}
    }
  }

</script>
<div class="Start_a_New_Campaign_Wrapper">
  <a href="/#/advertiser/upload-ad">
    <button class="main new_campaign">
      <img src="static/icons/New_Plus_Sign.png" 
      alt="add new campaign">
      Start a New Campaign
    </button>
  </a>
</div>
<div class="Campaigns">
  <div class="Campaigns_Body">
    <div class="Current_Campaigns">
      <div class="Page_Title">
        <span>Your Campaigns</span>
      </div>
      {#await getCurrentAdsProm}
        <p>loading your information...</p>
      {:then ads}
	{#if ads.length === 0}
	  <p>Looks like you have no campaigns. Get started by clicking "Start a New Campaign"</p>
	{/if}
        {#each ads as ad}
          <div on:click="{() => changeToCurrentCampaigns(ad._id)}" class="ad">
            <AdImg adId={ad.bucketId} height="200" />
          </div>
        {/each}
      {:catch error}
        <p>Something went wrong: {error.message}</p>
      {/await}
    </div>
  </div>
</div>
